import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/components/utils/utils";

interface ItineraryCardSkeletonProps {
  className?: string;
}

/** Segnaposto di ItineraryCard mentre arriva la pagina: stesse misure, nessun salto. */
export const ItineraryCardSkeleton = ({ className }: ItineraryCardSkeletonProps) => (
  <Card
    aria-hidden="true"
    className={cn("border border-gray-200 rounded-2xl overflow-hidden", className)}
  >
    <CardContent className="p-0 h-full flex flex-col">
      {/* Copertina, con badge di stato in alto a sinistra e menu in alto a destra */}
      <div className="relative w-full h-[150px]">
        {/* Toni chiari: lo scheletro accenna la forma, non deve farsi notare. Le aree grandi
            stanno sul grigio piu' tenue, badge e menu sopra la copertina sono velature bianche. */}
        <Skeleton className="absolute inset-0 rounded-none bg-gray-50" />
        <Skeleton className="absolute top-3 left-3 h-6 w-28 rounded-full bg-white/80" />
        <Skeleton className="absolute top-3 right-3 h-9 w-9 rounded-full bg-white/80" />
      </div>

      <div className="flex-1 p-3 flex flex-col">
        {/* Titolo */}
        <Skeleton className="h-5 w-3/4 mb-4" />

        {/* Date / ospiti / prezzo */}
        <div className="flex items-center justify-between mb-4">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-4 w-8" />
          <Skeleton className="h-4 w-14" />
        </div>

        {/* Persona */}
        <div className="flex items-center gap-2 mt-auto">
          <Skeleton className="h-7 w-7 rounded-full" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    </CardContent>
  </Card>
);
